import { Component, h, State, Prop, Element, Listen, Watch } from '@stencil/core';
import scrolltoTopIcon from '../../../assets/svg/scroll-to-top-icon.svg';
import { setFlexComponentPosition } from '../../components-helpers/components-helpers';

@Component({
  tag: 'svs-scroll-to-top-button',
  styleUrl: 'svs-scroll-to-top-button.scss',
  shadow: false,
})
export class ScrollToTopButton {
  /**
   * User device height
   */
  @State() scrollThreshhold = window.innerHeight;

  /**
   * Icon visibility state
   */
  @State() isIconVisible = false;

  /**
 * Allow changing position by another components
 */
  @Prop() readonly top?: number;
  @Prop() readonly bottom = 11;
  @Prop() readonly left?: number;
  @Prop() readonly right = 20;
  @Element() element;

  @State() bottomState = this.bottom;

  @Watch('top')
  @Watch('bottom')
  @Watch('left')
  @Watch('right')
  setPosition() {
      setFlexComponentPosition(this, '.scroll-to-top', false);
  }

  private handleScrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  @Listen('scroll', { target: 'window' })
  handleUserScroll() {
      this.isIconVisible = window.scrollY > this.scrollThreshhold;
  }

  componentDidLoad() {
      setFlexComponentPosition(this, '.scroll-to-top', false);
  }

  render() {
      return (
        <div
          class={{ 'scroll-to-top': true, visible: this.isIconVisible }}
          onClick={() => this.handleScrollToTop()}
          innerHTML={scrolltoTopIcon}
        />
      );
  }
}
